import { Drawer, Spin, Tag, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { Avatar } from "antd";
import { Link, useParams } from "react-router-dom";

import CommonFooter from "../../../../../../core/common/footer/commonFooter";

import axios from "axios";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import Swal from "sweetalert2";
import dayjs from "dayjs";
// import { CloseOutlined } from "@ant-design/icons";
import Table from "../../../../../../core/pagination/datatable";

const ContactsTab = () => {
  const [openAddContact, setOpenAddContact] = useState(false);
  const [openEditContact, setOpenEditContact] = useState(false);
  const [editContact, setEditContact] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    position: "",
    active: "",
    is_primary: "",
  });

  const avatarColors = [
    "#0d6efd",
    "#198754",
    "#dc3545",
    "#fd7e14",
    "#6f42c1",
    "#20c997",
    "#e83e8c",
    "#0dcaf0",
  ];

  const getAvatarColor = (FullName = "") => {
    if (!FullName) return avatarColors[0];
    const index = FullName.charCodeAt(0) % avatarColors.length;
    return avatarColors[index];
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "FullName",
      key: "FullName",

      sorter: (a, b) => (a.FullName || "").localeCompare(b.FullName || ""),

      render: (_, record) => {
        const isPrimary = record.is_primary === 1;

        return (
          <div className="d-flex align-items-center">
            <Avatar
              style={{
                backgroundColor: isPrimary
                  ? "#198754"
                  : getAvatarColor(record.FullName),
                marginRight: 10,
                fontWeight: 600,
              }}
            >
              {(record.FullName || "?")
                .split(" ")
                .map((x) => x[0])
                .join("")
                .substring(0, 2)
                .toUpperCase()}
            </Avatar>

            <Tooltip title={record.FullName || "N/A"}>
              <span
                className="fw-semibold"
                style={{
                  color: isPrimary ? "#198754" : "inherit",
                }}
              >
                {(record.FullName || "N/A").length > 11
                  ? `${record.FullName.substring(0, 11)}...`
                  : record.FullName || "N/A"}
              </span>
            </Tooltip>
          </div>
        );
      },
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
      render: (email) => (
        <Tooltip title={email || "N/A"}>
          <span>
            {email
              ? email.length > 10
                ? `${email.substring(0, 10)}...`
                : email
              : "N/A"}
          </span>
        </Tooltip>
      ),
    },

    {
      title: "Mobile",
      dataIndex: "phonenumber",

      render: (phonenumber) => (
        <small className=" d-flex align-items-center mt-1">
          <a href={`tel:${phonenumber}`} className="text-decoration-none">
            <i className="fa-solid fa-phone text-success me-2"></i>
            <span>{phonenumber || "N/A"}</span>
          </a>

          <a
            href={`https://wa.me/${phonenumber?.replace(/\D/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="ms-3"
            title="Chat on WhatsApp"
          >
            <i
              className="fa-brands fa-whatsapp text-success"
              style={{ fontSize: "16px" }}
            ></i>
          </a>
        </small>
      ),
    },

    {
      title: "Position",
      dataIndex: "title",
      key: "title",

      sorter: (a, b) => a.title.localeCompare(b.title),
      render: (title) => (
        <Tooltip title={title || "N/A"}>
          <span>
            {title
              ? title.length > 10
                ? `${title.substring(0, 10)}...`
                : title
              : "N/A"}
          </span>
        </Tooltip>
      ),
    },

    {
      title: "Date",
      dataIndex: "datecreated",
      key: "datecreated",
      sorter: (a, b) => new Date(a.datecreated) - new Date(b.datecreated),
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : "N/A"),
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      align: "center",
      sorter: (a, b) => Number(a.active) - Number(b.active),

      render: (active) =>
        active === 1 ? (
          <Tag color="success">Active</Tag>
        ) : (
          <Tag color="error">Inactive</Tag>
        ),
    },

    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action ">
            <Link
              to="#"
              className="me-2 p-2  shadow-sm"
              onClick={() => {
                setEditContact({
                  id: record.id,
                  firstName: record.firstname,
                  lastName: record.lastname,
                  email: record.email,
                  phone: record.phonenumber,
                  position: record.title,
                  is_primary: record.is_primary,
                  active: record.active,
                });
                setOpenEditContact(true);
              }}
            >
              <i className="ti ti-pencil text-primary"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const { id } = useParams();
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  console.log(userId, id);

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log(contacts, loading);

  const getContacts = async (Id) => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetContacts?userid=${Id}`,
      );

      if (response.data.Status) {
        setContacts(response.data.ResultData || []);
      } else {
        setContacts([]);

        Swal.fire({
          title: "Warning",
          text: response.data.Message || "No contacts found.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Get Contacts Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getContacts(id);
    }
  }, [id]);

  //Add contact

  const [contactFormData, setContactFormData] = useState({
    userid: id,
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    title: "",
    is_primary: 0,
    active: 1,
  });

  const handelReset = () => {
    setContactFormData({
      userid: id,
      firstname: "",
      lastname: "",
      email: "",
      phonenumber: "",
      title: "",
      is_primary: 0,
      active: 1,
    });
    setOpenAddContact(false);
  };

  const [saving, setSaving] = useState(false);
  const [update, setUpdate] = useState(false);

  const addContact = async () => {
    setSaving(true);

    try {
      const payload = {
        userid: id,
        firstname: contactFormData.firstname,
        lastname: contactFormData.lastname,
        email: contactFormData.email,
        phonenumber: contactFormData.phonenumber,
        title: contactFormData.title,
        is_primary: contactFormData.is_primary,
        active: contactFormData.active,
      };

      console.log("Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}customers/AddContact`,
        payload,
      );

      if (response.data.Status) {
        await Swal.fire({
          title: "Success",
          text: response.data.Message || "Contact added successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        // Close the offcanvas
        setOpenAddContact(false);

        getContacts(id);

        setContactFormData({
          userid: id,
          firstname: "",
          lastname: "",
          email: "",
          phonenumber: "",
          title: "",
          is_primary: 0,
          active: 1,
        });
      } else {
        Swal.fire({
          title: "Warning",
          text: response.data.Message || "Unable to add contact.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Add Contact Error:", error);
    } finally {
      setSaving(false);
    }
  };

  const handleContactChange = (e) => {
    const { name, value, type, checked } = e.target;

    setContactFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  //edit integration

  const handleUpdateContact = async () => {
    setUpdate(true);
    try {
      const payload = {
        id: editContact.id,
        firstname: editContact.firstName,
        lastname: editContact.lastName,
        email: editContact.email,
        phonenumber: editContact.phone,
        title: editContact.position,
        is_primary: editContact.is_primary,
        active: editContact.active,
      };

      const response = await axios.post(
        `${BASE_CRM_URL}/customers/UpdateContact`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.Status) {
        await Swal.fire({
          title: "Success",
          text: response.data.Message || "Contact updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });

        setOpenEditContact(false);

        // Refresh contacts
        getContacts(id);
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.Message || "Failed to update contact.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Update Contact Error:", error);
    } finally {
      setUpdate(false);
    }
  };

  return (
    <>
      <div>
        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>

            {/* </div> */}
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="page-btn">
                <Link
                  to="#"
                  className="btn btn-success btn-sm me-2"
                  onClick={() => setOpenAddContact(true)}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              {/* <Table columns={columns} dataSource={contacts} /> */}

              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={contacts} />
              )}
            </div>
          </div>
        </div>

        <CommonFooter />
      </div>

      <div>
        {saving && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              zIndex: 1050,
              backdropFilter: "blur(4px)",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <Drawer
          title="Add New Contact"
          placement="right"
          width={500}
          open={openAddContact}
          onClose={() => handelReset()}
          destroyOnClose
          closable={false}
          extra={
            <>
              {/* <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setOpenAddContact(false)}
            /> */}

              <div className="d-flex justify-content-end gap-2">
                {/* <Button type="text" icon={<CloseOutlined />} onClick={onClose} /> */}

                <button
                  type="button"
                  onClick={() => handelReset()}
                  disabled={loading}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#e40d22",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Close"
                >
                  <i className="fa fa-times" />
                </button>

                <button
                  type="button"
                  onClick={addContact}
                  disabled={saving}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#07f083",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Save"
                >
                  {saving ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    />
                  ) : (
                    <i className="fa fa-check" />
                  )}
                </button>
              </div>
            </>
          }
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              addContact();
            }}
          >
            <div className="row">
              {/* First Name */}
              <div className="col-6 mb-2">
                <label className="form-label">
                  <span className="text-danger">*</span> First Name
                </label>
                <input
                  type="text"
                  name="firstname"
                  className="form-control"
                  placeholder="Enter First Name"
                  value={contactFormData.firstname}
                  onChange={handleContactChange}
                  required
                />
              </div>

              {/* Last Name */}
              <div className="col-6 mb-2">
                <label className="form-label">
                  <span className="text-danger">*</span> Last Name
                </label>
                <input
                  type="text"
                  name="lastname"
                  className="form-control"
                  placeholder="Enter Last Name"
                  value={contactFormData.lastname}
                  onChange={handleContactChange}
                  required
                />
              </div>

              {/* Email */}
              <div className="col-12 mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter Email"
                  value={contactFormData.email}
                  onChange={handleContactChange}
                />
              </div>

              {/* Phone */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  <span className="text-danger">*</span> Phone Number
                </label>
                <input
                  type="tel"
                  name="phonenumber"
                  className="form-control"
                  placeholder="Enter Phone Number"
                  value={contactFormData.phonenumber}
                  onChange={handleContactChange}
                  required
                />
              </div>

              {/* Position */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  <span className="text-danger">*</span> Position
                </label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  placeholder="Enter Title"
                  value={contactFormData.title}
                  onChange={handleContactChange}
                />
              </div>

              {/* Primary Contact */}
              <div className="col-12 mb-2">
                <label className="form-label d-block">Primary Contact</label>

                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="is_primary"
                    checked={contactFormData.is_primary === 1}
                    onChange={handleContactChange}
                  />
                  <label className="form-check-label ms-2">
                    {contactFormData.is_primary === 1 ? "Yes" : "No"}
                  </label>
                </div>
              </div>
            </div>

            {/* <div className="d-flex justify-content-end ">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => setOpenAddContact(false)}
            >
              Close
            </button>

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
          </div> */}
          </form>
        </Drawer>
      </div>

      <div>
        {update && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              zIndex: 1050,
              backdropFilter: "blur(4px)",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <Drawer
          title="Edit Contact"
          placement="right"
          width={500}
          open={openEditContact}
          onClose={() => setOpenEditContact(false)}
          destroyOnClose
          closable={false}
          extra={
            <>
              {/* <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => setOpenAddContact(false)}
            /> */}

              <div className="d-flex justify-content-end gap-2">
                {/* <Button type="text" icon={<CloseOutlined />} onClick={onClose} /> */}

                <button
                  type="button"
                  onClick={() => openEditContact(false)}
                  disabled={update}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#e40d22",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Close"
                >
                  <i className="fa fa-times" />
                </button>

                <button
                  type="button"
                  onClick={handleUpdateContact}
                  disabled={update}
                  className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    backgroundColor: "#07f083",
                    color: "#fff",
                    border: "none",
                  }}
                  title="Save"
                >
                  {update ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    />
                  ) : (
                    <i className="fa fa-check" />
                  )}
                </button>
              </div>
            </>
          }
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleUpdateContact();
            }}
          >
            <div className="row">
              {/* First Name */}
              <div className="col-6 mb-3">
                <label className="form-label">
                  <span className="text-danger">*</span> First Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={editContact.firstName}
                  onChange={(e) =>
                    setEditContact({
                      ...editContact,
                      firstName: e.target.value,
                    })
                  }
                />
              </div>

              {/* Last Name */}
              <div className="col-6 mb-3">
                <label className="form-label">
                  <span className="text-danger">*</span> Last Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={editContact.lastName}
                  onChange={(e) =>
                    setEditContact({
                      ...editContact,
                      lastName: e.target.value,
                    })
                  }
                />
              </div>

              {/* Email */}
              <div className="col-12 mb-3">
                <label className="form-label">Email</label>

                <input
                  type="email"
                  className="form-control"
                  value={editContact.email}
                  onChange={(e) =>
                    setEditContact({
                      ...editContact,
                      email: e.target.value,
                    })
                  }
                />
              </div>

              {/* Phone */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  <span className="text-danger">*</span> Phone Number
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={editContact.phone}
                  onChange={(e) =>
                    setEditContact({
                      ...editContact,
                      phone: e.target.value,
                    })
                  }
                />
              </div>

              {/* Position */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  <span className="text-danger">*</span> Position
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={editContact.position}
                  onChange={(e) =>
                    setEditContact({
                      ...editContact,
                      position: e.target.value,
                    })
                  }
                />
              </div>

              {/* Status */}
              <div className="col-6 mb-3">
                <label className="form-label d-block">Status</label>

                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={editContact.active === 1}
                    onChange={(e) =>
                      setEditContact({
                        ...editContact,
                        active: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                  <label className="form-check-label ms-2">
                    {editContact.active === 1 ? "Active" : "Inactive"}
                  </label>
                </div>
              </div>

              {/* Primary Contact */}
              <div className="col-6 mb-3">
                <label className="form-label d-block">Primary Contact</label>

                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={editContact.is_primary === 1}
                    onChange={(e) =>
                      setEditContact({
                        ...editContact,
                        is_primary: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                  <label className="form-check-label ms-2">
                    {editContact.is_primary === 1 ? "Yes" : "No"}
                  </label>
                </div>
              </div>
            </div>

            {/* <div className="d-flex justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => setOpenEditContact(false)}
            >
              Close
            </button>

         

            <button type="submit" className="btn btn-primary" disabled={update}>
              {update ? "Updateing..." : "Update"}
            </button>
          </div> */}
          </form>
        </Drawer>
      </div>
    </>
  );
};

export default ContactsTab;
